<template>
  <el-dialog
    :model-value="props.visible"
    title=""
    width="500"
    align-center
    modal-class="go-class-11"
    destroy-on-close
    :close-on-click-modal="false"
    @open="onOpen"
    @closed="closedModal"
  >
    <div v-loading="pageLoading">
      <div class="dia-wrap">
        <div class="my-header">
          <div class="title">
            {{ props.currentRow.title }}
          </div>
          <div class="grow"></div>
          <div class="deco">
            <img src="https://static.rhkj.com/renhe_fe/other/200_1.png"/>
          </div>
        </div>

        <div class="main-box">
          <div v-if="props.currentRow.content?.text" class="text">
            {{ props.currentRow.content?.text }}
          </div>
          <div
            v-if="props.currentRow.content?.pcImgUrl"
            class="imgs">
            <el-image
              :src="props.currentRow.content.pcImgUrl"
              fit="cover"
              preview-teleported
              :preview-src-list="(props.currentRow.content.pcImgUrl && props.currentRow.content.pcImgUrl.split(',') || [])"
              :initial-index="0"
            />
          </div>
        </div>

        <div class="bottom">
          <el-button
            v-if="props.currentRow.content?.pcLink"
            plain
            color="#317FFD"
            style="width: 136px;"
            type="primary"
            @click="afterRed"
          >查看详情
          </el-button>
          <el-button
            style="margin-left: 20px;width: 136px;"
            color="#317FFD"
            type="primary"
            @click="afterRed"
          >我已知晓
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {ElMessage, ElMessageBox} from "element-plus";
import {notificationRead} from "@/api/messageCenter/index.js";
import {openMsgLink} from "@/views/studyCenter/pop/messageLink.js";
/*
 * 通用消息通知弹层--对应crm弹窗管理
 */

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  currentRow: {
    type: Object,
    default: () => {
    }
  }
})

const pageLoading = ref(false)

function onOpen() {

}

function afterRed() {
  closedModal()
  notificationRead({
    ids: [props.currentRow.id],
    readSource: 'PC',
    readDevice: navigator.userAgent,
  })
  if (props.currentRow.content?.pcLink) { // 存在pc链接，则打开
    openMsgLink({linkUrl: props.currentRow.content.pcLink})
  }
}


const emit = defineEmits(['update:visible'])

function closedModal() {
  emit('update:visible', false)
}
</script>

<style scoped lang="scss">
.dia-wrap {

  .my-header {
    height: 60px;
    background: linear-gradient(180deg, #DBEBFA 0%, #F9FBFD 100%);
    border-radius: 8px 8px 0 0;
    display: flex;
    padding: 19px;
    box-sizing: border-box;

    .title {
      font-size: 16px;
      line-height: 22px;
      color: #000000;
    }

    .grow {
      flex-grow: 1;
    }

    .deco {
      position: relative;

      > img {
        width: 78px;
        height: 78px;
        position: absolute;
        left: -70px;
        top: -36px;
      }
    }
  }

  .main-box {
    min-height: 50px;
    padding: 20px 16px;
    box-sizing: border-box;
    background-color: #FFFFFF;

    .text {
      color: #333333;
      font-size: 14px;
      line-height: 20px;
      padding-bottom: 10px;
      white-space: pre-wrap;
    }
  }

  .bottom {
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
    border-radius: 0 0 8px 8px;
  }
}
</style>

<style lang="scss">
.go-class-11 {
  .el-dialog {
    padding: 0;
    background-color: transparent;

    .el-dialog__header {
      display: none;
    }
  }
}
</style>
